<template>
  <ApplicationWrapper :hideHeader="false">
    <template slot="header">
      <b><h2>{{ $t('common.label_errorOccured') }}</h2></b>
    </template>
    <template slot="details">
      <v-row no-gutters class="my-4">
        <v-col class="d-flex align-center px-4">
          <Detail class="text-center ma-0" :containerNoPadding="true" :containerNoMargin="true">
            <template slot="header">
              <v-list-item-title>
                <b>
                  <u>
                    <h4>{{ $t('common.label_requestInfo') }}</h4>
                  </u>
                </b>
              </v-list-item-title>

              <!-- mailing information -->
              <v-list-item-subtitle class="px-1">
                <br />
                <v-row>
                  <v-col>
                    <!-- controller -->
                    <v-text-field
                      readonly
                      error
                      filled
                      color="error"
                      append-icon="mdi-content-copy"
                      @click:append="copyToClipboard(errorObj.controller)"
                      :label="$t('common.label_controller')"
                      v-model="errorObj.controller" />
                  </v-col>
                  <v-col>
                    <!-- action -->
                    <v-text-field
                      readonly
                      error
                      filled
                      color="error"
                      append-icon="mdi-content-copy"
                      @click:append="copyToClipboard(errorObj.action)"
                      :label="$t('common.label_action')"
                      v-model="errorObj.action" />
                  </v-col>
                </v-row>
                <br />
                <v-row>
                  <v-col>
                    <!-- AxiosError -->
                    <v-text-field
                      readonly
                      error
                      filled
                      color="error"
                      append-icon="mdi-content-copy"
                      @click:append="copyToClipboard(errorObj.axiosErrorCode)"
                      :label="$t('common.label_axiosError')"
                      v-model="errorObj.axiosErrorCode" />
                  </v-col>
                  <v-col>
                    <!-- http responsecode -->
                    <v-text-field
                      readonly
                      error
                      filled
                      color="error"
                      append-icon="mdi-content-copy"
                      @click:append="copyToClipboard(errorObj.httpStatus)"
                      :label="$t('common.label_httpStatus')"
                      v-model="errorObj.httpStatus" />
                  </v-col>
                </v-row>
                <br />
                <v-row>
                  <v-col>
                    <!-- full route -->
                    <v-textarea
                      readonly
                      error
                      filled
                      color="error"
                      append-icon="mdi-content-copy"
                      @click:append="copyToClipboard(errorObj.fullRoute)"
                      auto-grow
                      rows="2"
                      :label="$t('common.label_fullRoute')"
                      v-model="errorObj.fullRoute" />
                  </v-col>
                </v-row>
                <v-row no-gutters class="text-center">
                  <v-col>
                    <b>
                      <u>
                        {{ $t('common.label_paramInfo') }}
                      </u>
                    </b>
                  </v-col>
                </v-row>
                <v-row>
                  <!-- route parameters -->
                  <v-col v-if="errorObj.routeParameters && errorObj.routeParameters.length > 0" cols="6">
                    <v-card class="ma-2 pa-1">
                      <v-row>
                        <v-col>
                          <u>
                            {{ $t('common.label_routeParameter') }}
                          </u>
                        </v-col>
                      </v-row>
                      <v-row>
                        <!-- value -->
                        <v-col cols="4" class="text-left"> {{ $t('common.label_number') }} </v-col>
                        <!-- routeparam -->
                        <v-col cols="auto" class="text-left"> {{ $t('common.label_paramValue') }} </v-col>
                      </v-row>
                      <div v-for="(routeParam, index) of errorObj.routeParameters" :key="'routeparam_' + index + '_' + routeParam">
                        <v-row>
                          <!-- value -->
                          <v-col cols="4" class="text-left"> {{ index + 1 + '.' }} </v-col>
                          <!-- routeparam -->
                          <v-col cols="auto" class="text-left"> {{ routeParam }} </v-col>
                        </v-row>
                      </div>
                    </v-card>
                  </v-col>

                  <!-- query parameters -->
                  <v-col v-if="errorObj.queryParameters && errorObj.queryParameters.length > 0" cols="6">
                    <v-card class="ma-2 pa-1">
                      <v-row>
                        <v-col>
                          <u>
                            {{ $t('common.label_queryParameter') }}
                          </u>
                        </v-col>
                      </v-row>
                      <v-row>
                        <!-- value -->
                        <v-col cols="6" class="text-left"> {{ $t('common.label_paramName') }} </v-col>
                        <!-- routeparam -->
                        <v-col cols="auto" class="text-left"> {{ $t('common.label_paramValue') }} </v-col>
                      </v-row>
                      <div v-for="(queryParam, index) of errorObj.queryParameters" :key="'routeparam_' + index + '_' + queryParam.key">
                        <v-row>
                          <!-- value -->
                          <v-col cols="6" class="text-left"> {{ queryParam.key }} </v-col>
                          <!-- routeparam -->
                          <v-col cols="auto" class="text-left"> {{ queryParam.value }} </v-col>
                        </v-row>
                      </div>
                    </v-card>
                  </v-col>
                </v-row>
              </v-list-item-subtitle>
            </template>
          </Detail>
        </v-col>
        <v-col class="d-flex align-center px-4">
          <Detail class="text-center ma-0" :containerNoPadding="true" :containerNoMargin="true">
            <template slot="header">
              <v-list-item-title>
                <b>
                  <u>
                    <h4>{{ $t('common.label_errorMessage') }}</h4>
                  </u>
                </b>
              </v-list-item-title>

              <v-list-item-subtitle class="px-1">
                <br />
                <!-- name of the error -->
                <v-textarea
                  readonly
                  error
                  filled
                  color="error"
                  append-icon="mdi-content-copy"
                  @click:append="copyToClipboard(errorObj.errorName)"
                  auto-grow
                  rows="2"
                  :label="$t('common.label_errorName')"
                  v-model="errorObj.errorName" />
                <br />
                <!-- stacktrace -->
                <v-textarea
                  readonly
                  error
                  filled
                  color="error"
                  append-icon="mdi-content-copy"
                  @click:append="copyToClipboard(errorObj.errorMessage)"
                  auto-grow
                  rows="4"
                  :label="$t('common.label_errorMessage')"
                  v-model="errorObj.errorMessage" />
              </v-list-item-subtitle>
            </template>
          </Detail>
        </v-col>
      </v-row>
    </template>

    <template slot="actionbuttons">
      <v-row justify="space-around" align="center">
        <!-- back to login -->
        <v-btn color="primary" @click="backToLogin">
          <v-icon left> mdi-arrow-left </v-icon>
          {{ $t('common.label_backToLogin') }}
        </v-btn>
        <!-- copy error url -->
        <v-btn color="primary" @click="copyToClipboard(window.location.href)">
          <v-icon left> mdi-content-copy </v-icon>
          {{ $t('common.label_copyErrorUrl') }}
        </v-btn>
      </v-row>
    </template>
  </ApplicationWrapper>
</template>

<script>
// mixins
import Booking from '@/mixins/booking.js';
import HelpersMixin from '@/mixins/helpers.js';


// components
import ApplicationWrapper from '@/components/controls/ApplicationWrapper.vue';
import Detail from '@/components/controls/Detail.vue';

export default {
  name: 'ErrorView',

  mixins: [Booking, HelpersMixin],

  components: {
    ApplicationWrapper,
    Detail,
  },

  data() {
    return {
      errorObj: {},
    };
  },

  mounted() {
    // as soon as this component is mounted, the SessionData must be reset
    this.reset();
    // If a customer encounters an error, they can send their error URL to us and we can take another look at the error
    // therefore the errorObj is located in the query parameters and must first be converted into a Javascript object.
    this.errorObj = JSON.parse(this.$route.query.errorObj);
  },

  methods: {
    backToLogin() {
      this.$router.go(-1);
      //.push('Index', { params: [this.$router.params.clubId] });
    },
  },
};
</script>
